import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { CustomerInfo } from "../type";
import CustomAxios from "../utils/CustomAxios";

const REGION = process.env.REACT_APP_REGION as string;

interface CustomerInfoContextType {
  customerInfo: CustomerInfo;
  getCustomerInfo: () => Promise<void>;
  isCustomerLoading: boolean;
  pointData: number;
  balanceData: number;
}

const CustomerInfoContext = createContext<CustomerInfoContextType>({
  customerInfo: {
    uuid: "",
    email: "",
    phoneNumber: "",
    reduceCO2: 0,
    jCredit: 0,
  },
  getCustomerInfo: async () => {},
  isCustomerLoading: false,
  pointData: 0,
  balanceData: 0,
});

export const CustomerInfoProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [customerInfo, setCustomerInfo] = useState<CustomerInfo>({
    uuid: "",
    email: "",
    phoneNumber: "",
    reduceCO2: 0,
    jCredit: 0,
  });
  const [pointData, setPointData] = useState<number>(0);
  const [balanceData, setBalanceData] = useState<number>(0);
  const [isCustomerLoading, setIsCustomerLoading] = useState<boolean>(false);

  const getCustomerInfo = useCallback(async () => {
    setIsCustomerLoading(true);
    try {
      const res = await CustomAxios.get("/customer");
      setPointData(Number(res.data.balanceList[REGION].point));
      setBalanceData(Number(res.data.balanceList[REGION].value));
      setCustomerInfo({
        uuid: res.data.uuid,
        email: res.data.email,
        phoneNumber: res.data.phoneNumber,
        reduceCO2: res.data.reduceCo2,
        jCredit: res.data.jCredit,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setIsCustomerLoading(false);
    }
  }, []);

  useEffect(() => {
    getCustomerInfo();
  }, [getCustomerInfo]);

  return (
    <CustomerInfoContext.Provider
      value={{
        customerInfo,
        getCustomerInfo,
        isCustomerLoading,
        pointData,
        balanceData,
      }}
    >
      {children}
    </CustomerInfoContext.Provider>
  );
};

export const useCustomerInfoContext = () => useContext(CustomerInfoContext);
